<template>
  <div class="footer">
    <div class="myMain">
      <img
        class="footerLogo"
        src="@/assets/PC/navigation/navigation-logo.png"
        alt=""
      />
      <div class="menuList">
        <div class="product menuItem">
          <div class="itemTitle">{{ $t('publicFooter.products') }}</div>
          <ul class="itemList">
            <li
              v-for="(item, index) in productList"
              :key="index"
              @click="jump(item.routeName)"
            >
              {{ $t(`publicFooter.${item.text}`) }}
            </li>
          </ul>
        </div>
        <div class="solutions menuItem">
          <div class="itemTitle">{{ $t('publicFooter.solutions') }}</div>
          <ul class="itemList">
            <!-- <li>{{$t('publicFooter.solutions1')}}</li> -->
            <li @click="jump('solution')">
              {{ $t('publicFooter.solutions2') }}
            </li>
          </ul>
        </div>
        <div class="company menuItem">
          <div class="itemTitle">{{ $t('publicFooter.company') }}</div>
          <ul class="itemList">
            <li @click="jump('company')">{{ $t('publicFooter.company1') }}</li>
          </ul>
        </div>
        <div class="contact menuItem">
          <div class="itemTitle">{{ $t('publicFooter.contactUs') }}</div>
          <ul class="itemList">
            <li>
              {{ $t('publicFooter.contactUs2') }}
              <a
                v-if="$i18n.locale === 'id'"
                href="mailto:Support_info@cloudun.ai"
              >
                : Support_info@cloudun.ai
              </a>
              <a v-else href="mailto:operation@cloudun.ai">
                : operation@cloudun.ai
              </a>
            </li>
            <!-- <li>{{$t('publicFooter.contactUs1')}}: +62 877 75637420</li> -->
          </ul>
        </div>
      </div>
    </div>
    <div class="batch">
      <div class="myMain">©Copyright Cloudun PTE. LTD</div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      productList: [
        {
          text: 'product1',
          routeName: 'aiAds'
        },
        {
          text: 'product2',
          routeName: 'ekyc'
        },
        {
          text: 'product3',
          routeName: 'lunaAi'
        },
        {
          text: 'product4',
          routeName: 'antiFraud'
        },
        {
          text: 'product5',
          routeName: 'creditScore'
        }
      ]
    }
  },
  mounted () {
    this.changeProductList()
  },
  methods: {
    jump (name) {
      if (name !== this.$route.name) {
        this.$router.push({ name })
      } else {
        window.scrollTo(0, 0)
      }
    },
    changeProductList () {
      if (this.$i18n.locale === 'id') {
        this.productList = [
          {
            text: 'product4',
            routeName: 'antiFraud'
          },
          {
            text: 'product5',
            routeName: 'creditScore'
          }
        ]
      } else {
        this.productList = [
          {
            text: 'product1',
            routeName: 'aiAds'
          },
          {
            text: 'product2',
            routeName: 'ekyc'
          },
          {
            text: 'product3',
            routeName: 'lunaAi'
          },
          {
            text: 'product4',
            routeName: 'antiFraud'
          },
          {
            text: 'product5',
            routeName: 'creditScore'
          }
        ]
      }
    }
  }
}
</script>

<style scoped lang="less">
.footer {
  background-color: #fff;
  text-align: left;
}
.footerLogo {
  width: 4rem;
  margin: 1.6rem 0;
}
.menuList {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 1.6rem;
  > div {
    height: 100%;
  }
  .menuItem {
    .itemTitle {
      font-size: 0.4rem;
      color: #2e3433;
      margin-bottom: 0.4rem;
      font-weight: 500;
    }
    .itemList {
      cursor: pointer;
      li {
        color: #929594;
        font-size: 0.28rem;
        margin-bottom: 0.24rem;
        &:hover {
          color: #007660;
          text-decoration: underline;
        }
        a {
          color: #007660;
          font-weight: 500;
        }
      }
    }
  }
  .product {
    width: 20%;
  }
  .solutions {
    width: 35%;
  }
  .company {
    width: 20%;
  }
  .contact {
    width: 25%;
  }
}
.batch {
  width: 100%;
  background-color: #f6f8f7;
  padding: 0.44rem 0;
  .myMain {
    text-align: center;
    color: #919594;
    font-size: 0.28rem;
  }
}
</style>
